// Base
import parse from "html-react-parser";

// Store
import { useTemplateStore } from "@/zustand/templateStore";
import type { TemplateStore } from "@/types/types";

// Components
import Box from "@/components/Box";

interface FeatureItem {
  icon: string;
  label: string;
}

export default function FeaturesList() {
  const { featuresSavings, settings } = useTemplateStore() as Pick<
    TemplateStore,
    "featuresSavings" | "settings"
  >;

  if (!featuresSavings) return null;

  return (
    <Box className="shadow-cc gap-4 p-3 md:p-4">
      <div className="flex flex-col justify-center gap-4 md:flex-row">
        {featuresSavings.features_list &&
          featuresSavings.features_list.map(
            (item: FeatureItem, index: number) => (
              <div
                key={index}
                className="flex flex-1 flex-row items-center gap-2 md:flex-col"
              >
                <img
                  src={item.icon}
                  alt="Feature Icon"
                  className="w-8 md:w-10"
                />
                <span
                  className={`text-sm font-medium md:text-center ${
                    settings.enable_high_contrast
                      ? "text-cc-dark-gray"
                      : "text-cc-gray"
                  }`}
                >
                  <span className="md:block">{item.label.split(" ")[0]} </span>
                  <span className="md:block">
                    {item.label.split(" ").slice(1).join(" ")}
                  </span>
                </span>
              </div>
            ),
          )}
      </div>

      <div
        className={`h-px w-full ${
          settings.enable_high_contrast ? "bg-cc-gray-5" : "bg-gray-300"
        }`}
      />

      <div className="hidden gap-4 md:flex">
        <img src={featuresSavings.discount_icon} alt="Discount Icon" />
        <div className="flex flex-col justify-center gap-4">
          <span
            className={`text-xl font-bold ${settings.enable_high_contrast ? "text-cc-red" : "text-cc-dark-red-2"}`}
          >
            {featuresSavings.tr_title}
          </span>
          <span>{parse(featuresSavings.tr_description)}</span>
        </div>
      </div>

      <div className="flex flex-col gap-2 md:hidden">
        <div className="flex items-center gap-4">
          <img src={featuresSavings.discount_icon} alt="Discount Icon" />
          <span
            className={`text-xl font-bold ${settings.enable_high_contrast ? "text-cc-red" : "text-cc-dark-red-2"}`}
          >
            {featuresSavings.tr_title}
          </span>
        </div>
        <span>{parse(featuresSavings.tr_description)}</span>
      </div>
    </Box>
  );
}
